/**
 * Wow family api
 * The Wow family API description
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpParameterCodec }       from '@angular/common/http';
import { CustomHttpParameterCodec }                          from '../encoder';
import { Observable }                                        from 'rxjs';

import { ActionDto } from '../model/models';
import { ChanceNodeActionDto } from '../model/models';
import { ChanceNodeDto } from '../model/models';
import { ChanceNodeLogDto } from '../model/models';
import { ChanceNodeLogsDto } from '../model/models';
import { ChanceNodeRunsDto } from '../model/models';
import { ChanceNodesDto } from '../model/models';
import { CreateChanceNodeActionDto } from '../model/models';
import { CreateChanceNodeDto } from '../model/models';
import { TriggerDto } from '../model/models';
import { UpdateChanceNodeActionDto } from '../model/models';
import { UpdateChanceNodeDto } from '../model/models';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import {
    ChanceNodesServiceInterface,
    ChanceNodeControllerCreateChanceNodeRequestParams,
    ChanceNodeControllerCreateChanceNodeActionRequestParams,
    ChanceNodeControllerDeleteChanceNodeRequestParams,
    ChanceNodeControllerDeleteChanceNodeActionRequestParams,
    ChanceNodeControllerGetChanceNodesRequestParams,
    ChanceNodeControllerGetRunLogsRequestParams,
    ChanceNodeControllerGetScenarioRunsRequestParams,
    ChanceNodeControllerRunScenarioForStoreRequestParams,
    ChanceNodeControllerUpdateChanceNodeRequestParams,
    ChanceNodeControllerUpdateChanceNodeActionRequestParams,
    ChanceNodePublicControllerRunScenarioForStoreRequestParams
} from './chance-nodes.serviceInterface';



@Injectable({
  providedIn: 'root'
})
export class ChanceNodesService implements ChanceNodesServiceInterface {

    protected basePath = 'http://localhost';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();
    public encoder: HttpParameterCodec;

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (configuration) {
            this.configuration = configuration;
        }
        if (typeof this.configuration.basePath !== 'string') {
            if (typeof basePath !== 'string') {
                basePath = this.basePath;
            }
            this.configuration.basePath = basePath;
        }
        this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
    }


    private addToHttpParams(httpParams: HttpParams, value: any, key?: string): HttpParams {
        if (typeof value === "object" && value instanceof Date === false) {
            httpParams = this.addToHttpParamsRecursive(httpParams, value);
        } else {
            httpParams = this.addToHttpParamsRecursive(httpParams, value, key);
        }
        return httpParams;
    }

    private addToHttpParamsRecursive(httpParams: HttpParams, value?: any, key?: string): HttpParams {
        if (value == null) {
            return httpParams;
        }

        if (typeof value === "object") {
            if (Array.isArray(value)) {
                (value as any[]).forEach( elem => httpParams = this.addToHttpParamsRecursive(httpParams, elem, key));
            } else if (value instanceof Date) {
                if (key != null) {
                    httpParams = httpParams.append(key,
                        (value as Date).toISOString().substr(0, 10));
                } else {
                   throw Error("key may not be null if value is Date");
                }
            } else {
                Object.keys(value).forEach( k => httpParams = this.addToHttpParamsRecursive(
                    httpParams, value[k], key != null ? `${key}.${k}` : k));
            }
        } else if (key != null) {
            httpParams = httpParams.append(key, value);
        } else {
            throw Error("key may not be null if value is not object or array");
        }
        return httpParams;
    }

    /**
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public chanceNodeControllerCreateChanceNode(requestParameters: ChanceNodeControllerCreateChanceNodeRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<ChanceNodeDto>;
    public chanceNodeControllerCreateChanceNode(requestParameters: ChanceNodeControllerCreateChanceNodeRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<ChanceNodeDto>>;
    public chanceNodeControllerCreateChanceNode(requestParameters: ChanceNodeControllerCreateChanceNodeRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<ChanceNodeDto>>;
    public chanceNodeControllerCreateChanceNode(requestParameters: ChanceNodeControllerCreateChanceNodeRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {
        const createChanceNodeDto = requestParameters.createChanceNodeDto;
        if (createChanceNodeDto === null || createChanceNodeDto === undefined) {
            throw new Error('Required parameter createChanceNodeDto was null or undefined when calling chanceNodeControllerCreateChanceNode.');
        }

        let headers = this.defaultHeaders;

        let credential: string | undefined;
        // authentication (bearer) required
        credential = this.configuration.lookupCredential('bearer');
        if (credential) {
            headers = headers.set('Authorization', 'Bearer ' + credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType_ = 'text';
        }

        return this.httpClient.post<ChanceNodeDto>(`${this.configuration.basePath}/chance-nodes`,
            createChanceNodeDto,
            {
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public chanceNodeControllerCreateChanceNodeAction(requestParameters: ChanceNodeControllerCreateChanceNodeActionRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<ChanceNodeActionDto>;
    public chanceNodeControllerCreateChanceNodeAction(requestParameters: ChanceNodeControllerCreateChanceNodeActionRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<ChanceNodeActionDto>>;
    public chanceNodeControllerCreateChanceNodeAction(requestParameters: ChanceNodeControllerCreateChanceNodeActionRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<ChanceNodeActionDto>>;
    public chanceNodeControllerCreateChanceNodeAction(requestParameters: ChanceNodeControllerCreateChanceNodeActionRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {
        const createChanceNodeActionDto = requestParameters.createChanceNodeActionDto;
        if (createChanceNodeActionDto === null || createChanceNodeActionDto === undefined) {
            throw new Error('Required parameter createChanceNodeActionDto was null or undefined when calling chanceNodeControllerCreateChanceNodeAction.');
        }
        const chanceNodeId = requestParameters.chanceNodeId;
        if (chanceNodeId === null || chanceNodeId === undefined) {
            throw new Error('Required parameter chanceNodeId was null or undefined when calling chanceNodeControllerCreateChanceNodeAction.');
        }

        let headers = this.defaultHeaders;

        let credential: string | undefined;
        // authentication (bearer) required
        credential = this.configuration.lookupCredential('bearer');
        if (credential) {
            headers = headers.set('Authorization', 'Bearer ' + credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType_ = 'text';
        }

        return this.httpClient.post<ChanceNodeActionDto>(`${this.configuration.basePath}/chance-nodes/${encodeURIComponent(String(chanceNodeId))}/actions`,
            createChanceNodeActionDto,
            {
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public chanceNodeControllerDeleteChanceNode(requestParameters: ChanceNodeControllerDeleteChanceNodeRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<ChanceNodeDto>;
    public chanceNodeControllerDeleteChanceNode(requestParameters: ChanceNodeControllerDeleteChanceNodeRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<ChanceNodeDto>>;
    public chanceNodeControllerDeleteChanceNode(requestParameters: ChanceNodeControllerDeleteChanceNodeRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<ChanceNodeDto>>;
    public chanceNodeControllerDeleteChanceNode(requestParameters: ChanceNodeControllerDeleteChanceNodeRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {
        const chanceNodeId = requestParameters.chanceNodeId;
        if (chanceNodeId === null || chanceNodeId === undefined) {
            throw new Error('Required parameter chanceNodeId was null or undefined when calling chanceNodeControllerDeleteChanceNode.');
        }

        let headers = this.defaultHeaders;

        let credential: string | undefined;
        // authentication (bearer) required
        credential = this.configuration.lookupCredential('bearer');
        if (credential) {
            headers = headers.set('Authorization', 'Bearer ' + credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType_: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType_ = 'text';
        }

        return this.httpClient.delete<ChanceNodeDto>(`${this.configuration.basePath}/chance-nodes/${encodeURIComponent(String(chanceNodeId))}`,
            {
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public chanceNodeControllerDeleteChanceNodeAction(requestParameters: ChanceNodeControllerDeleteChanceNodeActionRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<ChanceNodeActionDto>;
    public chanceNodeControllerDeleteChanceNodeAction(requestParameters: ChanceNodeControllerDeleteChanceNodeActionRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<ChanceNodeActionDto>>;
    public chanceNodeControllerDeleteChanceNodeAction(requestParameters: ChanceNodeControllerDeleteChanceNodeActionRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<ChanceNodeActionDto>>;
    public chanceNodeControllerDeleteChanceNodeAction(requestParameters: ChanceNodeControllerDeleteChanceNodeActionRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {
        const chanceNodeId = requestParameters.chanceNodeId;
        if (chanceNodeId === null || chanceNodeId === undefined) {
            throw new Error('Required parameter chanceNodeId was null or undefined when calling chanceNodeControllerDeleteChanceNodeAction.');
        }
        const chanceNodeActionId = requestParameters.chanceNodeActionId;
        if (chanceNodeActionId === null || chanceNodeActionId === undefined) {
            throw new Error('Required parameter chanceNodeActionId was null or undefined when calling chanceNodeControllerDeleteChanceNodeAction.');
        }

        let headers = this.defaultHeaders;

        let credential: string | undefined;
        // authentication (bearer) required
        credential = this.configuration.lookupCredential('bearer');
        if (credential) {
            headers = headers.set('Authorization', 'Bearer ' + credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType_: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType_ = 'text';
        }

        return this.httpClient.delete<ChanceNodeActionDto>(`${this.configuration.basePath}/chance-nodes/${encodeURIComponent(String(chanceNodeId))}/actions/${encodeURIComponent(String(chanceNodeActionId))}`,
            {
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public chanceNodeControllerGetActions(observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<Array<ActionDto>>;
    public chanceNodeControllerGetActions(observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<Array<ActionDto>>>;
    public chanceNodeControllerGetActions(observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<Array<ActionDto>>>;
    public chanceNodeControllerGetActions(observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {

        let headers = this.defaultHeaders;

        let credential: string | undefined;
        // authentication (bearer) required
        credential = this.configuration.lookupCredential('bearer');
        if (credential) {
            headers = headers.set('Authorization', 'Bearer ' + credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType_: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType_ = 'text';
        }

        return this.httpClient.get<Array<ActionDto>>(`${this.configuration.basePath}/actions`,
            {
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public chanceNodeControllerGetChanceNodes(requestParameters: ChanceNodeControllerGetChanceNodesRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<ChanceNodesDto>;
    public chanceNodeControllerGetChanceNodes(requestParameters: ChanceNodeControllerGetChanceNodesRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<ChanceNodesDto>>;
    public chanceNodeControllerGetChanceNodes(requestParameters: ChanceNodeControllerGetChanceNodesRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<ChanceNodesDto>>;
    public chanceNodeControllerGetChanceNodes(requestParameters: ChanceNodeControllerGetChanceNodesRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {
        const limit = requestParameters.limit;
        if (limit === null || limit === undefined) {
            throw new Error('Required parameter limit was null or undefined when calling chanceNodeControllerGetChanceNodes.');
        }
        const page = requestParameters.page;
        if (page === null || page === undefined) {
            throw new Error('Required parameter page was null or undefined when calling chanceNodeControllerGetChanceNodes.');
        }

        let queryParameters = new HttpParams({encoder: this.encoder});
        if (limit !== undefined && limit !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>limit, 'limit');
        }
        if (page !== undefined && page !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>page, 'page');
        }

        let headers = this.defaultHeaders;

        let credential: string | undefined;
        // authentication (bearer) required
        credential = this.configuration.lookupCredential('bearer');
        if (credential) {
            headers = headers.set('Authorization', 'Bearer ' + credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType_: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType_ = 'text';
        }

        return this.httpClient.get<ChanceNodesDto>(`${this.configuration.basePath}/chance-nodes`,
            {
                params: queryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public chanceNodeControllerGetRunLogs(requestParameters: ChanceNodeControllerGetRunLogsRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<ChanceNodeLogsDto>;
    public chanceNodeControllerGetRunLogs(requestParameters: ChanceNodeControllerGetRunLogsRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<ChanceNodeLogsDto>>;
    public chanceNodeControllerGetRunLogs(requestParameters: ChanceNodeControllerGetRunLogsRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<ChanceNodeLogsDto>>;
    public chanceNodeControllerGetRunLogs(requestParameters: ChanceNodeControllerGetRunLogsRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {
        const chanceNodeId = requestParameters.chanceNodeId;
        if (chanceNodeId === null || chanceNodeId === undefined) {
            throw new Error('Required parameter chanceNodeId was null or undefined when calling chanceNodeControllerGetRunLogs.');
        }
        const runId = requestParameters.runId;
        if (runId === null || runId === undefined) {
            throw new Error('Required parameter runId was null or undefined when calling chanceNodeControllerGetRunLogs.');
        }
        const limit = requestParameters.limit;
        if (limit === null || limit === undefined) {
            throw new Error('Required parameter limit was null or undefined when calling chanceNodeControllerGetRunLogs.');
        }
        const page = requestParameters.page;
        if (page === null || page === undefined) {
            throw new Error('Required parameter page was null or undefined when calling chanceNodeControllerGetRunLogs.');
        }

        let queryParameters = new HttpParams({encoder: this.encoder});
        if (limit !== undefined && limit !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>limit, 'limit');
        }
        if (page !== undefined && page !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>page, 'page');
        }

        let headers = this.defaultHeaders;

        let credential: string | undefined;
        // authentication (bearer) required
        credential = this.configuration.lookupCredential('bearer');
        if (credential) {
            headers = headers.set('Authorization', 'Bearer ' + credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType_: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType_ = 'text';
        }

        return this.httpClient.get<ChanceNodeLogsDto>(`${this.configuration.basePath}/chance-nodes/${encodeURIComponent(String(chanceNodeId))}/runs/${encodeURIComponent(String(runId))}/logs`,
            {
                params: queryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public chanceNodeControllerGetScenarioRuns(requestParameters: ChanceNodeControllerGetScenarioRunsRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<ChanceNodeRunsDto>;
    public chanceNodeControllerGetScenarioRuns(requestParameters: ChanceNodeControllerGetScenarioRunsRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<ChanceNodeRunsDto>>;
    public chanceNodeControllerGetScenarioRuns(requestParameters: ChanceNodeControllerGetScenarioRunsRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<ChanceNodeRunsDto>>;
    public chanceNodeControllerGetScenarioRuns(requestParameters: ChanceNodeControllerGetScenarioRunsRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {
        const chanceNodeId = requestParameters.chanceNodeId;
        if (chanceNodeId === null || chanceNodeId === undefined) {
            throw new Error('Required parameter chanceNodeId was null or undefined when calling chanceNodeControllerGetScenarioRuns.');
        }
        const limit = requestParameters.limit;
        if (limit === null || limit === undefined) {
            throw new Error('Required parameter limit was null or undefined when calling chanceNodeControllerGetScenarioRuns.');
        }
        const page = requestParameters.page;
        if (page === null || page === undefined) {
            throw new Error('Required parameter page was null or undefined when calling chanceNodeControllerGetScenarioRuns.');
        }

        let queryParameters = new HttpParams({encoder: this.encoder});
        if (limit !== undefined && limit !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>limit, 'limit');
        }
        if (page !== undefined && page !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>page, 'page');
        }

        let headers = this.defaultHeaders;

        let credential: string | undefined;
        // authentication (bearer) required
        credential = this.configuration.lookupCredential('bearer');
        if (credential) {
            headers = headers.set('Authorization', 'Bearer ' + credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType_: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType_ = 'text';
        }

        return this.httpClient.get<ChanceNodeRunsDto>(`${this.configuration.basePath}/chance-nodes/${encodeURIComponent(String(chanceNodeId))}/runs`,
            {
                params: queryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public chanceNodeControllerGetTriggers(observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<Array<TriggerDto>>;
    public chanceNodeControllerGetTriggers(observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<Array<TriggerDto>>>;
    public chanceNodeControllerGetTriggers(observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<Array<TriggerDto>>>;
    public chanceNodeControllerGetTriggers(observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {

        let headers = this.defaultHeaders;

        let credential: string | undefined;
        // authentication (bearer) required
        credential = this.configuration.lookupCredential('bearer');
        if (credential) {
            headers = headers.set('Authorization', 'Bearer ' + credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType_: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType_ = 'text';
        }

        return this.httpClient.get<Array<TriggerDto>>(`${this.configuration.basePath}/triggers`,
            {
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public chanceNodeControllerRunScenarioForStore(requestParameters: ChanceNodeControllerRunScenarioForStoreRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<Array<ChanceNodeLogDto>>;
    public chanceNodeControllerRunScenarioForStore(requestParameters: ChanceNodeControllerRunScenarioForStoreRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<Array<ChanceNodeLogDto>>>;
    public chanceNodeControllerRunScenarioForStore(requestParameters: ChanceNodeControllerRunScenarioForStoreRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<Array<ChanceNodeLogDto>>>;
    public chanceNodeControllerRunScenarioForStore(requestParameters: ChanceNodeControllerRunScenarioForStoreRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {
        const chanceNodeId = requestParameters.chanceNodeId;
        if (chanceNodeId === null || chanceNodeId === undefined) {
            throw new Error('Required parameter chanceNodeId was null or undefined when calling chanceNodeControllerRunScenarioForStore.');
        }
        const storeId = requestParameters.storeId;
        if (storeId === null || storeId === undefined) {
            throw new Error('Required parameter storeId was null or undefined when calling chanceNodeControllerRunScenarioForStore.');
        }

        let queryParameters = new HttpParams({encoder: this.encoder});
        if (storeId !== undefined && storeId !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>storeId, 'storeId');
        }

        let headers = this.defaultHeaders;

        let credential: string | undefined;
        // authentication (bearer) required
        credential = this.configuration.lookupCredential('bearer');
        if (credential) {
            headers = headers.set('Authorization', 'Bearer ' + credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType_: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType_ = 'text';
        }

        return this.httpClient.post<Array<ChanceNodeLogDto>>(`${this.configuration.basePath}/chance-nodes/${encodeURIComponent(String(chanceNodeId))}/runs`,
            null,
            {
                params: queryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public chanceNodeControllerUpdateChanceNode(requestParameters: ChanceNodeControllerUpdateChanceNodeRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<ChanceNodeDto>;
    public chanceNodeControllerUpdateChanceNode(requestParameters: ChanceNodeControllerUpdateChanceNodeRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<ChanceNodeDto>>;
    public chanceNodeControllerUpdateChanceNode(requestParameters: ChanceNodeControllerUpdateChanceNodeRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<ChanceNodeDto>>;
    public chanceNodeControllerUpdateChanceNode(requestParameters: ChanceNodeControllerUpdateChanceNodeRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {
        const updateChanceNodeDto = requestParameters.updateChanceNodeDto;
        if (updateChanceNodeDto === null || updateChanceNodeDto === undefined) {
            throw new Error('Required parameter updateChanceNodeDto was null or undefined when calling chanceNodeControllerUpdateChanceNode.');
        }
        const chanceNodeId = requestParameters.chanceNodeId;
        if (chanceNodeId === null || chanceNodeId === undefined) {
            throw new Error('Required parameter chanceNodeId was null or undefined when calling chanceNodeControllerUpdateChanceNode.');
        }

        let headers = this.defaultHeaders;

        let credential: string | undefined;
        // authentication (bearer) required
        credential = this.configuration.lookupCredential('bearer');
        if (credential) {
            headers = headers.set('Authorization', 'Bearer ' + credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType_ = 'text';
        }

        return this.httpClient.patch<ChanceNodeDto>(`${this.configuration.basePath}/chance-nodes/${encodeURIComponent(String(chanceNodeId))}`,
            updateChanceNodeDto,
            {
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public chanceNodeControllerUpdateChanceNodeAction(requestParameters: ChanceNodeControllerUpdateChanceNodeActionRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<ChanceNodeActionDto>;
    public chanceNodeControllerUpdateChanceNodeAction(requestParameters: ChanceNodeControllerUpdateChanceNodeActionRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<ChanceNodeActionDto>>;
    public chanceNodeControllerUpdateChanceNodeAction(requestParameters: ChanceNodeControllerUpdateChanceNodeActionRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<ChanceNodeActionDto>>;
    public chanceNodeControllerUpdateChanceNodeAction(requestParameters: ChanceNodeControllerUpdateChanceNodeActionRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {
        const updateChanceNodeActionDto = requestParameters.updateChanceNodeActionDto;
        if (updateChanceNodeActionDto === null || updateChanceNodeActionDto === undefined) {
            throw new Error('Required parameter updateChanceNodeActionDto was null or undefined when calling chanceNodeControllerUpdateChanceNodeAction.');
        }
        const chanceNodeId = requestParameters.chanceNodeId;
        if (chanceNodeId === null || chanceNodeId === undefined) {
            throw new Error('Required parameter chanceNodeId was null or undefined when calling chanceNodeControllerUpdateChanceNodeAction.');
        }
        const chanceNodeActionId = requestParameters.chanceNodeActionId;
        if (chanceNodeActionId === null || chanceNodeActionId === undefined) {
            throw new Error('Required parameter chanceNodeActionId was null or undefined when calling chanceNodeControllerUpdateChanceNodeAction.');
        }

        let headers = this.defaultHeaders;

        let credential: string | undefined;
        // authentication (bearer) required
        credential = this.configuration.lookupCredential('bearer');
        if (credential) {
            headers = headers.set('Authorization', 'Bearer ' + credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType_ = 'text';
        }

        return this.httpClient.patch<ChanceNodeActionDto>(`${this.configuration.basePath}/chance-nodes/${encodeURIComponent(String(chanceNodeId))}/actions/${encodeURIComponent(String(chanceNodeActionId))}`,
            updateChanceNodeActionDto,
            {
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public chanceNodePublicControllerRunScenarioForStore(requestParameters: ChanceNodePublicControllerRunScenarioForStoreRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<Array<ChanceNodeLogDto>>;
    public chanceNodePublicControllerRunScenarioForStore(requestParameters: ChanceNodePublicControllerRunScenarioForStoreRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<Array<ChanceNodeLogDto>>>;
    public chanceNodePublicControllerRunScenarioForStore(requestParameters: ChanceNodePublicControllerRunScenarioForStoreRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<Array<ChanceNodeLogDto>>>;
    public chanceNodePublicControllerRunScenarioForStore(requestParameters: ChanceNodePublicControllerRunScenarioForStoreRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {
        const chanceNodeId = requestParameters.chanceNodeId;
        if (chanceNodeId === null || chanceNodeId === undefined) {
            throw new Error('Required parameter chanceNodeId was null or undefined when calling chanceNodePublicControllerRunScenarioForStore.');
        }
        const storeId = requestParameters.storeId;

        let queryParameters = new HttpParams({encoder: this.encoder});
        if (storeId !== undefined && storeId !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>storeId, 'storeId');
        }

        let headers = this.defaultHeaders;

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType_: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType_ = 'text';
        }

        return this.httpClient.post<Array<ChanceNodeLogDto>>(`${this.configuration.basePath}/public/chance-nodes/${encodeURIComponent(String(chanceNodeId))}/run`,
            null,
            {
                params: queryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
